const googleMapConfig = {
	apiKey: 'AIzaSyBVKXTuUmnd2bWzg5ASXjY8DQIyCytL5CA'
};

export default googleMapConfig;
